<template>
	<div class="owl-carousel" @mouseover='stopSlider' @mouseout='startSlider'>
		<div class="item" v-for="item in items">
			<a v-if="item.img" :href="item.href" class="banner" :style="`background-image: url(${item.img})`">
      </a>
		</div>
	</div>
</template>

<script>
	module.exports = {
		props: ['items'],
		data () {
			return {
				interval: '',
				step: 0
			}
		},

		updated() {
			this.$emit('updated', {
				owlSettings: {
					items: 1,
					loop: this.items.length > 1 ? true : false,
					nav: false,
					responsive: {
						0: {
							items: 2,
						},
						400: {
							items: 2,
						},
						640: {
							items: 3,
						},
						800: {
							items: 5,
						},
						1180: {
							items: 7,
						}
					},
					onInitialized: (e) => {
					let v = $(e.target).find('.owl-stage').width();
					let wBlock = $('.slider-swimSlider').width();
						this.interval = setInterval(() => {
						// console.log(this.step);
						// console.log(-v + wBlock);
						if(this.step <= (-v + wBlock)){
							this.step = 0;
						}
						$(e.target).find('.owl-stage').css('transform', 'translateX('+ this.step +'px)');
							this.step--;
						}, 50);
					}
				}
			});
		},
	  methods: {

		stopSlider(e){
		  clearInterval(this.interval);
		},
		startSlider(e) {
		  let v = $(e.target).closest('.owl-stage').width();
				let wBlock = $('.slider-swimSlider').width();
		  this.interval = setInterval(() => {
					// console.log(this.step);
					// console.log(-v + wBlock);
			if(this.step <= (-v + wBlock)){
			  this.step = 0;
			}
			$(e.target).closest('.owl-carousel').find('.owl-stage').css('transform', 'translateX('+ this.step +'px)');
			this.step--;
		  }, 50);
		}
	  }
	}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
  width: 100%;
	.slider-swimSlider {
    @include single-transition();
    .owl-stage{
      @include single-transition();
    }
		.owl-carousel {
			.item {
        width: 100%;
        height: 100px;
        .banner{
          display: block;
          width: 100%;
          height: 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// swimSlider.vue?e17d64d2